<template>
  <div>
    <header-info cur="5"></header-info>
    <div id="center">
      <div
        id="content"
        class="content"
      >
        <div class="menu">
          <div class="banner-title"><img src="../../../assets/images/about-title.png"></div>
        </div>
        <div class="tips">
          <p></p>
        </div>

      </div>
    </div>

    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
export default {
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科' }
    ]
  },
  name: 'Platform',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {

  },
  mounted() {
    window.screenWidth = document.body.clientWidth
    if (window.screenWidth < 1000) {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
      }
    }
  }
}
</script>
<style scoped>
.menu {
  width: 100%;
  min-height: 310px;
  background: url(../../../assets/images/banner-about.jpg) no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tips {
  max-width: 1000px;
  padding: 20px 10px;
  margin: 0 auto;
  color: #666;
  font-size: 16px;
  line-height: 2em;
  text-indent: 2em;
  text-align: justify;
}
</style>
